export const WIZARD_TARGET_ATTRIBUTE = 'data-wizard-target';
/** Set on `document.documentElement` while a wizard tour is active. */
export const WIZARD_ACTIVE_HTML_ATTRIBUTE = 'data-wizard-active';
/** Step card root (`WizardStepCard`). */
export const WIZARD_STEP_CARD_ATTRIBUTE = 'data-wizard-step-card';

export const DEFAULT_WIZARD_SPOTLIGHT_PADDING = 0;

/** Stagger delay for the first step of a wizard (spotlight, then card). */
export const WIZARD_STEP_REVEAL_DELAY_MS = 400;

/** Max time to wait for the first step target before giving up on auto-start. */
export const WIZARD_TARGET_WAIT_TIMEOUT_MS = 15_000;

/** Curved caret below/above/beside the step card (see WizardStepCardPointer). */
export const WIZARD_STEP_CARD_POINTER_WIDTH = 32;
export const WIZARD_STEP_CARD_POINTER_HEIGHT = 24;
/** Overlap between pointer and step card edge for a seamless join. */
export const WIZARD_STEP_CARD_POINTER_CARD_OVERLAP_PX = 5;
/** Space between pointer tip and spotlight edge. */
export const WIZARD_STEP_CARD_POINTER_TARGET_GAP = 10;

/** SVG path for downward caret (rotated per placement in WizardStepCard). */
export function getWizardStepCardPointerPath(
  width: number,
  height: number,
): string {
  const centerX = width / 2;
  const tipY = height;
  // Pull sides toward center; lower Y = softer pinch before the tip.
  const waistY = height * 0.68;

  return [
    `M 2 0`,
    `Q ${centerX} 1.5 ${width - 2} 0`,
    `C ${width - 5} 2, ${centerX + 1.2} ${waistY}, ${centerX} ${tipY}`,
    `C ${centerX - 1.2} ${waistY}, 5 2, 2 0`,
    `Z`,
  ].join(' ');
}
